<template lang="pug">
button(v-if="authenticated" type="button" v-on="$listeners")
  slot
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters('auth', ['authenticated']),
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

button
  padding 1rem
  font-weight bold
  border-radius 5px
  border none
  outline none
  cursor pointer
  transition color 0.1s ease
  background #E67E22
  color white

  &:hover
    background-color #CA6F1E
</style>
